export default __webpack_public_path__ + "static/media/LinkedIn icon.a3d9695d.svg";